module.exports = __webpack_public_path__ + "static/media/alarm-clock.7d539205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarm-clock.png
// module id = 3433
// module chunks = 0